// extracted by mini-css-extract-plugin
module.exports = {"Component":"Component_Component__211AD","Compact":"Component_Compact__3_gkv","Larger":"Component_Larger__3kdEs"};